import Promo from "../Promo/Promo";
import Skills from "../Skills/Skills";
import EarningsBlock from "../EarningsBlock/EarningsBlock";
import Advantage from "../Advantage/Advantage";
import Description from "../Description/Description";
import Methodology from "../Methodology/Methodology";
import Price from "../Price/Price";
import Conditions from "../Сonditions/Сonditions";
import Faq from "../Fag/Faq";
import TeacherBlock from "../TeacherBlock/TeacherBlock";

function Main({isUnit}) {
  return (
    <main>
      <Promo />
      <Skills />
      <EarningsBlock />
      <TeacherBlock />
      <Advantage />
      <Description />
      <Methodology />
      <Price isUnit={isUnit} />
      <Conditions />
      <Faq />
    </main>
  );
}

export default Main;
